import * as actions from './actions';
import * as mutations from './mutations';

const state = {
    changeRequests: [],
}

const getters = {
    // ===== change request =====
    changeRequests: state => state.changeRequests,

    changeRequestsByTask: (state) => (taskId) => {
        
        return state.changeRequests.filter(r => r.taskId === taskId);
    },

    changeRequestMapByTask: (state) => (taskId) => {
        const map = {};

        state.changeRequests.forEach(r => {
            if (r.taskId === taskId && r.status === 0) {
                map[r.field] = r;
            }
        });

        return map;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}